const LinkingNoticeImage = (_: any) => null;

export default LinkingNoticeImage;
